/**
 * NDG Events Slider — view.js
 *
 * Enregistre le namespace Interactivity API (SSR data-wp-each).
 * Initialise Embla Carousel via le module partagé ndg/shared-slider.
 */

import { store, getElement } from '@wordpress/interactivity';
import { initSlider as initEmblaSlider } from '../../js/utils/slider.js';

store( 'ndg/events-slider', {
	callbacks: {
		initSlider() {
			const { ref } = getElement();
			if ( ! ref ) return;

			initEmblaSlider( ref, {
				wrapperSelector: '.ndg-evslider',
				labelSelector:   '.ndg-evslider__label',
				fallbackLabel:   'Événements',
				dragFree:        false,
			} );
		},
	},
} );
